import { useQuery } from '@tanstack/react-query'
import { useStore } from '@tanstack/react-store'
import { useEffect } from 'react'
import { api } from 'api'
import { PaymentsListFilter, paymentsListStore } from 'shared/store/paymentsList'
import { checkParam } from 'shared/utils/checkParam'
import { getDateTimeToSubmit } from 'shared/utils/dateFormatting'
import { toaster } from 'uikit/Toaster'

export const useFetchPaymentsList = ({ urlParams }: { urlParams: PaymentsListFilter }) => {
  const { size, page, sort, filter: storeFilter } = useStore(paymentsListStore)
  const mergedFilter = { ...storeFilter, ...urlParams }
  const { payeeCardNumber, ...filter } = mergedFilter

  const payeeCardNumberValue =
    payeeCardNumber && payeeCardNumber.slice(0, 6) + payeeCardNumber.slice(-4)

  const payload = {
    page,
    size,
    sort,
    payeeFIO: checkParam(filter.payeeFIO),
    payeeCardNumber: payeeCardNumberValue,
    payeePhone: checkParam(filter.payeePhone),
    payerPhone: checkParam(filter.payerPhone),
    paymentAmountMax: checkParam(filter.paymentAmountMax),
    paymentAmountMin: checkParam(filter.paymentAmountMin),
    paymentDateFrom: checkParam(getDateTimeToSubmit(filter.paymentDateFrom)),
    paymentDateTo: checkParam(getDateTimeToSubmit(filter.paymentDateTo)),
    paymentId: checkParam(filter.paymentId),
    paymentState: checkParam(filter.paymentState),
    paymentType: checkParam(filter.paymentType),
    rrn: checkParam(filter.rrn),
  }

  const response = useQuery({
    queryKey: ['paymentsList', payload],
    queryFn: () => api.payments.fetchPaymentsList(payload),
  })

  useEffect(() => {
    if (response.isSuccess && response.data) {
      const { totalElements, totalPages } = response.data

      paymentsListStore.setState((state) => ({
        ...state,
        totalElements,
        totalPages,
      }))
    }
  }, [response.isSuccess, response.data])

  useEffect(() => {
    if (response.isError && response.error) {
      toaster.create({
        title: 'Не удалось загрузить список платежей',
        description: response.error?.message,
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
  }, [response.isError, response.error])

  return response
}
